
import "./App.css";
import AccessComponent from "./route/route";

function App() {
  return (
    <div className="App">
      <AccessComponent />
    </div>
  );
}

export default App;